import { Reveal, SectionHead } from "../components/Reveal";

export default function WhyUs({ content }) {
  return (
    <section id="why-us" className="scroll-mt-20 py-24 sm:py-32 bg-coal border-y border-white/5" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          overline="Why Choose TheMapLab"
          title="The standard your vehicle deserves"
        />
        <div className="mt-14">
          {content.why.map((item, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div
                className="group grid md:grid-cols-[90px_1fr_1.6fr] items-baseline gap-2 md:gap-8 border-t border-white/10 py-8 last:border-b hover:bg-white/[0.02] transition-colors px-2 -mx-2"
                data-testid={`why-item-${i}`}
              >
                <span className="font-display text-lg font-semibold text-electric-bright">0{i + 1}</span>
                <h3 className="font-display text-xl sm:text-2xl font-medium uppercase tracking-tight text-white group-hover:translate-x-1 transition-transform">
                  {item.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-400 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
